
export default function CloseableCard({children, onClose}) {
    return (
        <div>
            {children}
            <button style={{marginTop: "5px"}} onClick={onClose}>❌ Odebrat referenci</button>
        </div>
    );
}